import React, { useEffect } from 'react';
import {
  BusinessAdministratorsCard,
  BusinessHeader,
  ManagersCard,
  BusinessPointsCard,
  Header,
} from 'widgets';
import { useParams } from 'react-router-dom';
import { businessStore } from 'entities/index';
import { observer } from 'mobx-react';
import { CardWithOverlay, PageLayout } from 'shared/ui';
import { Loading } from 'pages/loading/ui/loading.page';

export const BusinessPage: React.FC = observer(() => {
  const { id } = useParams();

  useEffect(() => {
    if (typeof id == 'string') {
      businessStore.initBusinessHeaderData(id);
    }
  }, []);

  return id ? (
    <PageLayout>
      <Header />
      <BusinessHeader />
      <CardWithOverlay title="Точки">
        <BusinessPointsCard businessId={id} />
      </CardWithOverlay>
      <CardWithOverlay title="Управляющие">
        <BusinessAdministratorsCard businessId={id} />
      </CardWithOverlay>
      <CardWithOverlay title="Менеджеры">
        <ManagersCard businessId={id} />
      </CardWithOverlay>
    </PageLayout>
  ) : (
    <Loading />
  );
});
